// extracted by mini-css-extract-plugin
module.exports = {"animateOnHoverContainer":"AnimateOnHoverArrow_animateOnHoverContainer__cSyXI","animateOnHover":"AnimateOnHoverArrow_animateOnHover__5KvKd"};